import { useMemo } from 'react';
import type { Machine } from '../../planning/types';

export function useDashboardCounts(machines: Machine[], today: string, tomorrow: string) {
  const arrivingToday = useMemo(
    () => machines.filter((m) => m.status === "ordered" && m.start_date === today).length,
    [machines, today]
  );
  const arrivingTomorrow = useMemo(
    () => machines.filter((m) => m.status === 'ordered' && m.start_date === tomorrow).length,
    [machines, tomorrow]
  );

  const pickupToday = useMemo(
    () =>
      machines.filter((m) => m.status === 'ordered' &&  m.pickup_on_end_date && m.end_date === today)
        .length,
    [machines, today]
  );
  const pickupTomorrow = useMemo(
    () =>
      machines.filter(
        (m) => m.status === 'ordered' && m.pickup_on_end_date && m.end_date === tomorrow
      ).length,
    [machines, tomorrow]
  );

  const actionToday = useMemo(
    () =>
      machines.filter(
        (m) => m.status === 'ordered' && !m.pickup_on_end_date && m.end_date === today
      ).length,
    [machines, today]
  );
  const actionTomorrow = useMemo(
    () =>
      machines.filter(
        (m) => m.status === 'ordered' && !m.pickup_on_end_date && m.end_date === tomorrow
      ).length,
    [machines, tomorrow]
  );

  const toOrderToday = useMemo(
    () => machines.filter((m) => m.status === 'to_order' && m.start_date === today).length,
    [machines, today]
  );
  const toOrderTomorrow = useMemo(
    () => machines.filter((m) => m.status === 'to_order' && m.start_date === tomorrow).length,
    [machines, tomorrow]
  );

  return {
    arrivingToday,
    arrivingTomorrow,
    pickupToday,
    pickupTomorrow,
    actionToday,
    actionTomorrow,
    toOrderToday,
    toOrderTomorrow,
  };
}
